import {AfterContentChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {PagingModel} from '../../iBoxx/shared/pagination-control/PagingModel';
import {GridReadyEvent} from 'ag-grid-community';
import {UtilService} from '../../iBoxx/services/UtilService';
import {LoaderService} from '../../iBoxx/shared/loader/loader-service.services';
import {ApiService} from '../../iBoxx/services/api.service';
import {ScreenerFilter} from '../../iBoxx/modals/ScreenerFilter';
import {DataSharingService} from '../../iBoxx/services/data-sharing.service';
import {SaveStateName} from '../../iBoxx/ngxs/screener-filter.action';
import {Store} from '@ngxs/store';
import {Router} from '@angular/router';

@Component({
  selector: 'app-emix-landing-page',
  templateUrl: './emix-landing-page.component.html',
  styleUrls: ['./emix-landing-page.component.scss']
})
export class EmixLandingPageComponent implements OnInit, AfterContentChecked {

  tabList = [''];
  dataLoaded = false;
  indexType = 'emix';
  screenerFilter: ScreenerFilter = new ScreenerFilter();
  homePageData = {
    indexFamilies : [],
    indexLevels : [],
  };
  filteredResult: any[] = [];
  rowData: any[] = [];
  columnDefs = [
    {
      headerName: 'Index Name', width: 300, maxWidth: 500, field: 'indexName',
      pinned: 'left', sortable: true,
      cellRenderer: (params: any) => {
        return params.data.indexName === null ? '' : '<span class="link">' + params.value + '</span>';
      },
      comparator: ((valueA: string, valueB: string) => valueA.toUpperCase() < valueB.toUpperCase() ? -1 : 1)
    },
    {headerName: 'Index Family', width: 200, maxWidth: 500, field: 'indexFamily', tooltipField: 'indexFamily',
      hide: false, sortable: true},
    {headerName: 'As Of Date', width: 90, field: 'asOf', sortable: true, comparator: () => 0},
    {headerName: 'Currency', hide: false, width: 80, field: 'currency', sortable: true},
    {headerName: 'EICode', hide: false, headerTooltip: 'EICode', width: 80, field: 'eiCode', sortable: true},
    {headerName: 'Gross Total Return', hide: false, headerTooltip: 'Gross Total Return', width: 100,
      field: 'grossTotalReturn', sortable: true, tooltipField: 'grossTotalReturn', comparator: () => 0
    },
    {headerName: 'Net Total Return', hide: false, width: 80, field: 'netTotalReturn', tooltipField: 'netTotalReturn',
      sortable: true, comparator: () => 0},
    {headerName: 'Price', hide: false, width: 80, field: 'price', tooltipField: 'price', sortable: true, comparator: () => 0},
  ];
  domLayout = 'autoHeight';
  indexGrid: any;
  pagingInfo: PagingModel = new PagingModel();
  showTooltip = false;
  tooltipData: any;
  alertMessage = 'Maximum 5 indices can be displayed';
  alertType = 'info';
  showAlert = false;
  showTimeoutAlert = false;
  timeoutMessage = '';
  timeout: any = null;

  constructor(private apiService: ApiService, private utilService: UtilService,
              private shareService: DataSharingService, private loader: LoaderService, private cdRef: ChangeDetectorRef,
              private store: Store, private route: Router) { }

  ngOnInit(): void {
    // @ts-ignore
    this.tabList = JSON.parse(window.sessionStorage.getItem('tabListForEMIX')) ? JSON.parse(window.sessionStorage.getItem('tabListForEMIX'))
      : ['screener', 'documentation'];

    this.homePageData = this.shareService.EMIXIndices;
    this.initPaging(this.homePageData.indexLevels.length);
    this.populateIndexData(this.homePageData.indexLevels);
    this.shareScreenerFilters(this.homePageData.indexLevels);
    this.dataLoaded = true;
    this.loader.hide();
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  onGridReady(event: GridReadyEvent): void {
    this.indexGrid = event.api;
    this.changePage();
  }

  onMouseOver(event: any): void{
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (event.colDef.headerName === 'Index Name'){
        this.tooltipData = event;
        // this.showTooltip = true;
      }
    }, 1000);
  }


  onGridSizeChanged(): void {
    this.utilService.agGridSizeColumnsToFit(this.indexGrid);
  }

  populateIndexData(results: any[]): void {
    this.rowData = [];
    results.forEach((result: any) => {
      const index: any = {};
      index.asOf = this.utilService.formatDate(result.asOf);
      index.currency = result.currency;
      index.eiCode = result.eiCode;
      index.id = result.id;
      index.indexName = result.indexName;
      index.indexFamily = result.indexMaster.indexFamily ? result.indexMaster.indexFamily.id : '';
      index.netTotalReturn = result.netTotalReturn ? parseFloat(result.netTotalReturn).toFixed(4) : '';
      index.price = result.price ? parseFloat(result.price).toFixed(4) : '';
      index.grossTotalReturn = result.grossTotalReturn ? parseFloat(result.grossTotalReturn).toFixed(4) : '';

      this.rowData.push(index);
    });
  }

  shareScreenerFilters(batchData: any): void{
    this.screenerFilter.indexCurrency = batchData.map((batch: any) => {
      return batch.currency;
    })
      .filter((elem: string, index: number, self: string) => {
        return index === self.indexOf(elem);
      });

    this.screenerFilter.indexFamily = [...new Set(this.homePageData.indexFamilies.map((family: any) => family.name))];
    this.screenerFilter.masterID = [...new Set(this.homePageData.indexLevels.map((level: any) => level.indexMaster.id))];
    this.screenerFilter.indexName = [...new Set(this.homePageData.indexLevels.map((level: any) => level.indexName))];

    this.shareService.filters.next(this.screenerFilter);
    this.shareService.filteredBatchData.next(batchData);
  }

  closeTooltip(): void{

  }

  openTab(event: any): void {
    switch (event) {
      case 'screener':
        break;
      case 'documentation':
        this.route.navigateByUrl('EMIX/docs/page?docFor=EMIX');
        break;
      default:
        const index = this.homePageData.indexLevels.find((level: any) => event === (level.indexName + ' (' + level.currency + ')'));
        this.getIndexDetailsFor(index);
        break;
    }
  }

  closeAlert(): void{
    this.showAlert = false;
  }

  applyFilterOnEmix(event: any): void{
    let result = JSON.parse(JSON.stringify(this.homePageData.indexLevels));
    Object.keys(event).forEach((key: string) => {
      this.shareService.filteredMap.set(key, event[key]);
      if (key === 'indexFamily'){
        result = this.utilService.getRecordsForIndexFamilyForEMIX(event[key], result);
      }else if (key === 'indexCurrency'){
        result = this.utilService.getRecordsForCurrencyForEMIX(event[key], result);
      }else if (key === 'masterID'){
        result = result.filter((res: any) => res.indexMaster.id.toUpperCase().includes(event[key].toUpperCase()));
      }else if (key === 'indexName'){
        result = result.filter((res: any) => res.indexName.toUpperCase().includes(event[key].toUpperCase()));
      }else{
        result = result.filter((data: any) => {
          if (event[key].split('~').includes(data[key])) {
            return data;
          }
        });
      }
    });

    this.shareService.filteredBatchData.next(result);
    this.populateFilteredResult(result);
  }

  clearFilter(): void{
    this.shareService.filterApplied = false;
    this.populateIndexData(this.homePageData.indexLevels);
    this.initPaging(this.homePageData.indexLevels.length);
    this.shareScreenerFilters(this.homePageData.indexLevels);
    this.changePage();
    this.utilService.agGridSizeColumnsToFit(this.indexGrid);
  }

  populateFilteredResult(result: any): void {
    this.filteredResult = result;
    this.updateTableForFilteredResult();
  }

  updateTableForFilteredResult(): void {
    this.pagingInfo.totalRows = this.filteredResult ? this.filteredResult.length : 0;
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
    this.pagingInfo.page = this.shareService.filterApplied
    && this.pagingInfo.totalPages > this.shareService.currentPage ? this.shareService.currentPage : 0;
    // this.paginateFilteredData();
    this.populateIndexData(this.filteredResult);
  }

  onSortChanged(event: any): void {
    const sortController = event.columnApi.getColumnState().find((col: any) => col.sort !== null);
    let tempCopy = this.shareService.filterApplied ? JSON.parse(JSON.stringify(this.filteredResult))
      : JSON.parse(JSON.stringify(this.rowData));
    if (sortController) {
      const blankRows = this.rowData.filter((data: any) => data[sortController.colId] === '');
      if (blankRows.length > 0){
        blankRows.forEach((row: any) => {
          const index = tempCopy.findIndex((temp: any) => temp.indexName === row.indexName &&
            temp.inflationAdjustment === row.inflationAdjustment);
          tempCopy.splice(index, 1);
        });
      }
      tempCopy = this.sortDataBasedOn(tempCopy, sortController.colId, sortController.sort);
      if (sortController.sort === 'asc'){
        blankRows.forEach((row: any) => tempCopy.splice(0, 0, row));
      }else{
        blankRows.forEach((row: any) => tempCopy.push(row));
      }
      if (this.shareService.filterApplied) {
        this.formatData(tempCopy);
      }
      this.indexGrid.setRowData(tempCopy);
    }else{
      this.populateIndexData(this.shareService.filterApplied ? this.filteredResult : this.homePageData.indexLevels);
    }
  }

  sortDataBasedOn(data: any, columnName: string, order: string): any{
    if (order === 'asc'){
      if (columnName === 'asOf'){
        return data.sort((d1: any, d2: any) => new Date(d1[columnName]).getTime() < new Date(d2[columnName]).getTime() ? -1 : 1);
      }
      return data.sort((d1: any, d2: any) => parseFloat(d1[columnName]) < parseFloat(d2[columnName]) ? -1 : 1);
    }else{
      if (columnName === 'asOf'){
        return data.sort((d1: any, d2: any) => new Date(d1[columnName]).getTime() > new Date(d2[columnName]).getTime() ? -1 : 1);
      }
      return data.sort((d1: any, d2: any) => parseFloat(d1[columnName]) < parseFloat(d2[columnName]) ? 1 : -1);
    }
  }

  formatData(data: any): void{
    data.forEach((res: any) => {
      res.asOf = this.utilService.formatDate(res.asOf);
      res.indexFamily = res.indexMaster.indexFamily ? res.indexMaster.indexFamily.id : '';
      res.netTotalReturn = res.netTotalReturn ? parseFloat(res.netTotalReturn).toFixed(4) : '';
      res.price = res.price ? parseFloat(res.price).toFixed(4) : '';
      res.grossTotalReturn = res.grossTotalReturn ? parseFloat(res.grossTotalReturn).toFixed(4) : '';

    });
  }

  initPaging(recordLength: number): void{
    this.pagingInfo.totalRows = recordLength;
    this.pagingInfo.pageSize = 15;
    this.pagingInfo.visibleRows = 15;
    this.pagingInfo.page = 0;
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
  }

  changePage(): void{
    this.indexGrid.paginationGoToPage(this.pagingInfo.page);
    this.indexGrid.paginationSetPageSize(this.pagingInfo.pageSize);
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
  }

  onRowSelected(): void {
    const selectedNodes = this.indexGrid.getSelectedNodes();
    const selectedData = selectedNodes.find((node: any) => node.isSelected()).data;
    this.getIndexDetailsFor(selectedData);
  }

  deselectRow(): void {
    const selectedNodes = this.indexGrid.getSelectedNodes();
    const currentNode = selectedNodes.find((node: any) => node.isSelected());
    currentNode.selected = false;
    while (document.getElementsByClassName('ag-row-selected').length > 0) {
      const rows = document.getElementsByClassName('ag-row-selected');
      rows[0].classList.remove('ag-row-selected');
    }
  }

  getIndexDetailsFor(index: any): void{
    if (!this.tabList.includes(index.indexName + ' (' + index.currency + ')')) {
      if (this.tabList.length < 7) {
        this.tabList.push(index.indexName + ' (' + index.currency + ')');
      } else {
        window.scrollTo(0, 0);
        this.showAlert = true;
        this.deselectRow();
      }
    }
    if (this.tabList.includes(index.indexName + ' (' + index.currency + ')')) {
      this.openIndexDetailsTab(index);
    }
  }

  openIndexDetailsTab(index: any): void {
    this.shareService.currentTab = index.indexName + ' (' + index.currency + ')';
    this.shareService.tabList.next(this.tabList);
    window.sessionStorage.setItem('tabListForEMIX', JSON.stringify(this.tabList));
    this.store.dispatch(new SaveStateName(this.indexType));
    this.route.navigateByUrl('EMIX/details/index?id=' + index.id);
  }
}
